import { Tag } from 'ui/tags';
import { colors } from 'ui/theme';
import { HelpToggletip } from 'ui/tooltip';
import { isUndefined } from 'utils/tsHelpers';
import {
  CaptionText,
  Container,
  Heading,
  Label,
  SecondaryValue,
  Value,
  ValueText,
} from './MetricTile.styled';

type Props = {
  label: string;
  value: number;
  tag?: string;
  tooltip?: string;
  caption?: string;
};

export const MetricTile = ({ label, tag, tooltip, caption, value = 0 }: Props) => (
  <Container>
    <Heading>
      <Label>{label}</Label>
      {tag && <Tag>{tag}</Tag>}
      {tooltip && (
        <HelpToggletip tooltipContent={tooltip} iconProps={{ color: colors.secondaryText }} />
      )}
      {caption && <CaptionText>{caption}</CaptionText>}
    </Heading>
    <Value>{value.toLocaleString()}</Value>
  </Container>
);

const createDataVariant = (value?: number, ofValue?: number) => {
  // value is not a number
  if (isUndefined(value)) {
    return 'unknown';
  }
  // value is a number but ofValue is not
  if (isUndefined(ofValue)) {
    return 'info';
  }

  // both are numbers
  return ofValue < value ? 'warning' : 'info';
};

interface SmartIngestMetricTileProps {
  label: string;
  value?: number;
  tag?: string;
  tooltip?: string;
  caption?: string;
  secondaryValue?: number;
}

export const SmartIngestMetricTile = ({
  label,
  tag,
  tooltip,
  caption,
  value,
  secondaryValue,
}: SmartIngestMetricTileProps) => {
  const dataVariant = createDataVariant(value, secondaryValue);

  return (
    <Container>
      <Heading>
        <Label>{label}</Label>
        {tag && <Tag>{tag}</Tag>}
        {tooltip && (
          <HelpToggletip tooltipContent={tooltip} iconProps={{ color: colors.secondaryText }} />
        )}
        {caption && <CaptionText>{caption}</CaptionText>}
      </Heading>
      <ValueText>
        <Value data-variant={dataVariant}>{value?.toLocaleString() ?? 'N/A'}</Value>
        {/* of value shouldn't be 0 so this works here without undefined check */}
        {secondaryValue && <SecondaryValue>of {secondaryValue}</SecondaryValue>}
      </ValueText>
    </Container>
  );
};
